import React, { useState } from "react";
import {
  Box,
  Grid,
  Stack,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { isEmpty } from "../../../../utils/validation";

const ListAssociations = ({ data }) => {
  return (
    <Box>
      <Stack gap={2}>
        <Typography variant="h4">Associazioni: </Typography>
        <Grid container spacing={2}>
          {!isEmpty(data)
            ? data.map((item, index) => (
                <Grid key={index} size={{ xs: 12, sm: 6, md: 3 }}>
                  <CardAssociation data={item} />
                </Grid>
              ))
            : null}
        </Grid>
      </Stack>
    </Box>
  );
};

const CardAssociation = ({ data }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const imageUrl =
    data.image_type && data.image
      ? `data:${data.image_type};base64,${data.image}`
      : "/no_img.png";

  return (
    <>
      <Card sx={{ maxWidth: 345 }}>
        <CardActionArea onClick={handleClickOpen}>
          <CardMedia
            component="img"
            height="140"
            image={imageUrl}
            alt="ImmagineProfilo"
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              {data.name}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {data.address}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>{data.name}</DialogTitle>
        <DialogContent dividers>
          <img
            src={imageUrl}
            alt="ImmagineProfilo"
            style={{
              width: "100%",
              maxHeight: 300,
              objectFit: "cover",
              marginBottom: 16,
            }}
          />
          <Typography variant="body1" gutterBottom>
            <strong>Descrizione:</strong> {data.description || "N/A"}
          </Typography>
          <Typography variant="body1" gutterBottom>
            <strong>Indirizzo:</strong> {data.address}
          </Typography>
          <Typography variant="body1" gutterBottom>
            <strong>Data di fondazione:</strong> {data.foundation_date || "N/A"}
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
            Statistiche
          </Typography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Voce</TableCell>
                  <TableCell align="right">Valore</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* Esempio di statistiche */}
                <TableRow>
                  <TableCell>Numero di volontari: </TableCell>
                  <TableCell align="right">
                    {data.admins_members_volunteer.n_vol ?? 0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Numero di amministratori: </TableCell>
                  <TableCell align="right">
                    {data.admins_members_volunteer.n_admins ?? 0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Numero di soci: </TableCell>
                  <TableCell align="right">
                    {data.admins_members_volunteer.n_members ?? 0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Numero di followers: </TableCell>
                  <TableCell align="right">
                    {data.admins_members_volunteer.n_followers ?? 0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Eventi totali: </TableCell>
                  <TableCell align="right">{data.total_events ?? 0}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Media eventi settimanali:</TableCell>
                  <TableCell align="right">
                    {data.average_weekly_events ?? 0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Media eventi mensili:</TableCell>
                  <TableCell align="right">
                    {data.average_monthly_events ?? 0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Numero medio turni:</TableCell>
                  <TableCell align="right">
                    {data.average_number_shifts ?? 0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Numero di notifiche inviate:</TableCell>
                  <TableCell align="right">
                    {data.number_notifications_sent ?? 0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Numero di richieste diventa volontario:</TableCell>
                  <TableCell align="right">
                    {data.number_requests_volunteer ?? 0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Numero di richieste iscrizione turni:</TableCell>
                  <TableCell align="right">
                    {data.number_requests_shift ?? 0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Numero medio di richieste per turni:</TableCell>
                  <TableCell align="right">
                    {data.average_requests_for_shift ?? 0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Numero di domande:</TableCell>
                  <TableCell align="right">
                    {data.number_questions ?? 0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Click associazione:</TableCell>
                  <TableCell align="right">
                    {data.number_clicks_association ?? 0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Click sui suoi eventi:</TableCell>
                  <TableCell align="right">
                    {data.number_clicks_event ?? 0}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Chiudi</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ListAssociations;
